import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import mesApi, { FlourTestHistoryItem } from "../../../Api/mes.api";
import FlourQualityShell from "./components/FlourQualityShell";
import { deviceSummaryBadge, formatHrDate, formatHrDateTime, formatNum, lotStatusLabel } from "./flourQualityUtils";

const FlourQualityHistory = () => {
  const [rows, setRows] = useState<FlourTestHistoryItem[]>([]);
  const [loading, setLoading] = useState(false);
  const [statusFilter, setStatusFilter] = useState<"" | "released" | "rejected">("");

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const data = await mesApi.getFlourTestHistory(
        statusFilter ? { status: statusFilter } : undefined
      );
      setRows(Array.isArray(data) ? data : []);
    } catch (err: any) {
      toast.error(err.message);
      setRows([]);
    } finally {
      setLoading(false);
    }
  }, [statusFilter]);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <FlourQualityShell>
      <ToastContainer position="top-center" autoClose={2500} />

      <div className="mes-section">
        <h3 style={{ margin: 0, border: "none", padding: 0 }}>Povijest testiranih LOT-ova</h3>
        <p className="iwt-role-hint" style={{ marginTop: 8 }}>
          Brašno koje je prošlo QC (pušteno ili odbijeno). Kliknite analizu za pregled svih mjerenja i blend-a.
        </p>
      </div>

      <div className="mes-section">
        <div className="wh-pregled-toolbar">
          <select
            className="filter-select"
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value as typeof statusFilter)}
          >
            <option value="">Svi ishodi</option>
            <option value="released">Pušteni</option>
            <option value="rejected">Odbijeni</option>
          </select>
          <button type="button" className="btn-secondary btn-sm" onClick={load} disabled={loading}>
            Osvježi
          </button>
        </div>

        {loading ? (
          <p>Učitavanje…</p>
        ) : rows.length === 0 ? (
          <p className="mes-hint">Nema zapisa.</p>
        ) : (
          <div className="mes-table-wrap">
            <table className="mes-table">
            <thead>
              <tr>
                <th>LOT</th>
                <th>Sirovina</th>
                <th>Status</th>
                <th>QC datum</th>
                <th>kg</th>
                <th>F / E / A</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => {
                const st = lotStatusLabel(r.status);
                return (
                  <tr key={r.lot_id}>
                    <td>
                      <strong>{r.internal_lot_code || r.lot_number_supplier || r.lot_id}</strong>
                    </td>
                    <td>{r.ingredient_name || "—"}</td>
                    <td><span className={st.className}>{st.label}</span></td>
                    <td>
                      {r.last_qc
                        ? formatHrDateTime(r.last_qc.decided_at)
                        : formatHrDateTime(r.released_at)}
                    </td>
                    <td className="fq-num">{formatNum(r.quantity_received_kg)}</td>
                    <td className="fq-device-mini">
                      {r.measurements && (
                        <>
                          <span className={deviceSummaryBadge(r.measurements.farinograph).className}>F</span>
                          <span className={deviceSummaryBadge(r.measurements.extensograph).className}>E</span>
                          <span className={deviceSummaryBadge(r.measurements.amylograph).className}>A</span>
                        </>
                      )}
                    </td>
                    <td>
                      <Link
                        to={`/mes/flour-analyses/lot/${r.lot_id}`}
                        className="btn-secondary btn-sm"
                      >
                        Analiza
                      </Link>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          </div>
        )}
      </div>
    </FlourQualityShell>
  );
};

export default FlourQualityHistory;
